export default {
    'pl': 'Polski',
    'en': 'Angielski'
}